<template>
  <div class="control-group">
    <div class="control" v-for="(item, index) in checkboxs" :key="index">
      <span>{{ item.label }}</span>
      <label class="checkbox">
        <input
          type="checkbox"
          :value="item.value"
          :checked="isChecked(item.value)"
          @click="changeValues(item.value, $event)"
          :disabled="disabled"
        />
        <div class="checkmark"></div>
      </label>
    </div>
    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="emitValues"
      :disabled="disabled"
    >
      OK
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    checkboxs: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      valueList: []
    }
  },
  methods: {
    isChecked(value) {
      return this.valueList.indexOf(value) > -1
    },
    changeValues(value, { target }) {
      if (target.checked) {
        this.valueList.push(value)
      } else {
        this.valueList = this.valueList.filter(v => v !== value)
      }
    },
    emitValues() {
      this.$emit('input', [...this.valueList])
    }
  }
}
</script>

<style scoped>
.control-group {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.control-group button {
  margin-left: 15px;
  margin-top: 16px;
}

.control {
  width: 25px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-left: 5px;
}

.control span {
  font-size: 14px;
  color: #a0aec0;
  font-weight: 700;
  cursor: default;
}

.checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-top: 0px;
  margin-bottom: 12px;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

.checkbox:hover input:disabled ~ .checkmark {
  cursor: default;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  cursor: pointer;
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: #468b35;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/common/CheckboxGroup.vue